import * as React from 'react';
import { Image, OverlayWithHeader, Text } from '@belong/ui';

export function FlowHeaderMobileTip({
  isOverlayOpen,
  closeOverlayModal,
  title,
  content,
  description = [],
}: FlowHeaderMobileTipProps): JSX.Element {
  const localDescription = Array.isArray(description)
    ? description
    : [description];

  return (
    <OverlayWithHeader
      name="mobile_navigation"
      isOpen={isOverlayOpen}
      onDismiss={closeOverlayModal}
    >
      <div className="pt-xl container">
        <div className="mb-sm flex items-center">
          <div className="mr-xs" style={{ width: 16 }}>
            <Image src="/icons/light-bulb.svg" alt="" />
          </div>
          <Text as="h3" fontWeight="semibold">
            {title}
          </Text>
        </div>
        {localDescription.map((text) => (
          <Text as="p" key={text} className="mt-xs">
            {text}
          </Text>
        ))}
        {content}
      </div>
    </OverlayWithHeader>
  );
}

type FlowHeaderMobileTipProps = {
  isOverlayOpen: boolean;
  closeOverlayModal: () => void;
  title: string;
  description?: string | string[];
  content?: React.ReactNode;
};
